import { render, staticRenderFns } from "./EnacAtplDashboardLevelReportLearners.vue?vue&type=template&id=6020bedb"
import script from "./EnacAtplDashboardLevelReportLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardLevelReportLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports